import { render, staticRenderFns } from "./AddRemoveButton.vue?vue&type=template&id=365d1c07&"
import script from "./AddRemoveButton.vue?vue&type=script&lang=js&"
export * from "./AddRemoveButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports